/**
 * J.Marin Parfume — Luxury theme interactions
 */
(function () {
  'use strict';

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initHeaderScroll() {
    const headerWrapper = document.querySelector('.header-wrapper');
    const hero = document.querySelector('.luxury-hero');
    if (!headerWrapper) return;

    const onScroll = () => {
      const scrolled = window.scrollY > 40;
      headerWrapper.classList.toggle('luxury-header--scrolled', scrolled);

      if (hero) {
        const heroBottom = hero.offsetTop + hero.offsetHeight;
        headerWrapper.classList.toggle('luxury-header--past-hero', window.scrollY > heroBottom - 80);
      }
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initHeroSections() {
    document.querySelectorAll('.luxury-hero').forEach((hero) => {
      hero.classList.add('luxury-hero--loaded');

      const img = hero.querySelector('.luxury-hero__media img');
      if (!img) return;
      if (img.complete) return;
      img.addEventListener('load', () => hero.classList.add('luxury-hero--loaded'));
    });
  }

  function initRevealElements() {
    if (prefersReducedMotion) return;

    const targets = document.querySelectorAll(
      '.luxury-story, .luxury-collections, .luxury-collections__card, .luxury-dual-cta__item, .luxury-manifesto, .luxury-cinematic'
    );

    if (!targets.length || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('luxury-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }
    );

    targets.forEach((el) => {
      el.classList.add('luxury-reveal');
      observer.observe(el);
    });
  }

  function initProductRail() {
    document.querySelectorAll('[data-luxury-rail]').forEach((rail) => {
      const progressBar = rail.closest('.luxury-products')?.querySelector('[data-luxury-rail-progress]');
      if (!progressBar) return;

      const updateProgress = () => {
        const maxScroll = rail.scrollWidth - rail.clientWidth;
        if (maxScroll <= 0) {
          progressBar.style.width = '100%';
          return;
        }
        const pct = (rail.scrollLeft / maxScroll) * 80 + 20;
        progressBar.style.width = pct + '%';
      };

      rail.addEventListener('scroll', updateProgress, { passive: true });
      updateProgress();
    });
  }

  function initParallaxHero() {
    if (prefersReducedMotion) return;

    const heroes = document.querySelectorAll('.luxury-hero__media img');
    if (!heroes.length) return;

    let ticking = false;

    const update = () => {
      heroes.forEach((img) => {
        const hero = img.closest('.luxury-hero');
        if (!hero) return;
        const rect = hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const progress = Math.min(1, Math.max(0, -rect.top / rect.height));
        img.style.transform = `scale(${1.03 + progress * 0.05}) translateY(${progress * 24}px)`;
      });
      ticking = false;
    };

    window.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  function onReady() {
    initHeaderScroll();
    initHeroSections();
    initRevealElements();
    initProductRail();
    initParallaxHero();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }

  document.addEventListener('shopify:section:load', onReady);
})();
